export default __webpack_public_path__ + "static/Helena-50620d7f06fcbcb269d6e2b7aa76d2cd6b8b5956bc6938880e1eca71ac82f249.svg";